import { Component, inject, viewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ComponentMap, RendererService } from '../../services/renderer.service';
import { FooterApartmentComponent } from '../../components/apartment/footer-apartment/footer-apartment.component';
import { NavbarApartmentComponent } from '../../components/apartment/navbar-apartment/navbar-apartment.component';
import { SlugService } from '../../services/slug.service';

const COMPONENT_MAP: ComponentMap = {
    ComponentMainHeader: import(
        '../../components/apartment/header/header.component'
    ).then((m) => m.HeaderComponent),
    ComponentMainDivider: () =>
        import('../../components/common/divider/divider.component').then(
            (m) => m.DividerComponent,
        ),
    ComponentMainNotFound: () =>
        import('../../components/common/not-found/not-found.component').then(
            (m) => m.NotFoundComponent,
        ),
    ComponentMainTextImage: () =>
        import('../../components/common/text-image/text-image.component').then(
            (m) => m.TextImageComponent,
        ),
    ComponentMainGallery: () =>
        import('../../components/common/gallery/gallery.component').then(
            (m) => m.GalleryComponent,
        ),
    ComponentMainSlider: () =>
        import('../../components/common/slider/slider.component').then(
            (m) => m.SliderComponent,
        ),
    ComponentMainTextField: () =>
        import('../../components/common/text-field/text-field.component').then(
            (m) => m.TextfieldComponent,
        ),
    ComponentMainTextFieldMarkdown: () =>
        import(
            '../../components/common/text-field-markdown/text-field-markdown.component'
        ).then((m) => m.TextFieldMarkdownComponent),
    ComponentMainContact: () =>
        import(
            '../../components/apartment/contact-apartment/contact-apartment.component'
        ).then((m) => m.ContactApartmentComponent),
    ComponentMainContactHof: () =>
        import('../../components/hof/contact-hof/contact-hof.component').then(
            (m) => m.ContactHofComponent,
        ),
    ComponentMainApartmentInfo: () =>
        import(
            '../../components/apartment/apartment-info/apartment-info.component'
        ).then((m) => m.ApartmentInfoComponent),
    ComponentMainTestimonials: () =>
        import(
            '../../components/apartment/testimonials/testimonials.component'
        ).then((m) => m.TestimonialsComponent),
    ComponentMainBooking: import(
        '../../components/apartment/booking/booking.component'
    ).then((m) => m.BookingComponent),
    ComponentMainPriceView: import(
        '../../components/apartment/price-view/price-view.component'
    ).then((m) => m.PriceViewComponent),
    ComponentMainMap: () =>
        import('../../components/common/map/map.component').then(
            (m) => m.MapComponent,
        ),
} as { [key: string]: any };

@Component({
    selector: 'app-apartment-renderer',
    imports: [NavbarApartmentComponent, FooterApartmentComponent],
    host: { class: 'block relative font-brandon' },
    templateUrl: './apartment-renderer.component.html',
})
export class ApartmentRendererComponent {
    viewContainerRef = viewChild('viewContainerRef', {
        read: ViewContainerRef,
    });
    private activatedRoute = inject(ActivatedRoute);
    private rendererService = inject(RendererService);
    private slugService = inject(SlugService);

    ngOnInit() {
        this.activatedRoute.params.subscribe((params) => {
            this.slugService.setSlug = params['slug'];
        });

        this.activatedRoute.data.subscribe((response: any) => {
            const data = response.page;
            this.rendererService.viewContainerRef.set(this.viewContainerRef());
            this.rendererService.loadComponents(
                data,
                COMPONENT_MAP,
                data.data[0]?.title,
                undefined,
            );
        });
    }
}
